export function flattenInfinitePages<T>(pages: { items: T[] }[] | undefined): T[] {
  if (!pages?.length) return [];
  return pages.flatMap((page) => page.items);
}

export function getNextPageParam(total: number, loadedCount: number, pageSize: number): number | undefined {
  if (loadedCount >= total) return undefined;
  return Math.floor(loadedCount / pageSize) + 1;
}
